import { gsap } from 'gsap'
import { debounce } from 'lodash'

class ComponentPositioner {
  constructor (obj) {
    if (obj) {
      this.init(obj)
    }
    else {
      this.active = false
      this.padding = 0

      this.el = null

      this.header = {
        el: null
      }

      this.body = {
        el: null
      }

      this.interface = {
        el: null
      }

      this.footer = {
        el: null
      }
    }
  }

  init (obj) {
    this.active = obj.active

    this.el = document.querySelector(obj.el)

    this.header = {
      el: document.querySelector(obj.header)
    }

    this.body = {
      el: document.querySelector(obj.body)
    }

    this.interface = {
      el: document.querySelector(obj.interface)
    }

    this.footer = {
      el: document.querySelector(obj.footer)
    }

    this.padding = 0

    this.checkFooterHeight()
  }

  checkFooterHeight () {
    if (!this.active) {
      gsap.set(this.footer.el, { height: 0 })
    }
  }

  toggleHeight (status = 'idle') {
    var tl = gsap.timeline({
      duration: 0.75,
      ease: 'back.out(1.3)'
    })

    if (!this.active) {
      // collapse
      tl.to(this.el, {
        onComplete: this.cbCenterOnComplete,
        onCompleteParams: [false],
        callbackScope: this
      }, 0)

      tl.to(this.body.el, {
        height: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        '--tw-border-opacity': 0
      }, 0)

      if (status === 'idle') {
        tl.to(this.footer.el, {
          height: 0,
          opacity: 0
        }, 0)
      }
    }
    else {
      // open up
      tl.to(this.el, {
        onComplete: this.cbCenterOnComplete,
        onCompleteParams: [true],
        callbackScope: this
      }, 0)

      tl.to(this.body.el, {
        height: 'auto',
        borderTopWidth: '1px',
        borderBottomWidth: '1px',
        '--tw-border-opacity': 100
      }, 0)

      tl.to(this.footer.el, {
        height: 'auto',
        opacity: 1
      }, 0)
    }

    tl.play()
  }

  resize () {
    // if (this.active) {
    // this.calculateDimensions()

    // gsap.to(this.el, {
    //   y: -(window.innerHeight / 2 - this.h / 2),
    //   onComplete: this.cbResizeOnComplete,
    //   // ease: 'back.out(1.3)'
    //   ease: 'linear'
    // })
    // }

    // Currently no vertical centering is needed, but keep the function
    // Meanwhile simply return true
    return true
  }

  moveWhenNavIsVisible (visible = false) {
    visible
      ? gsap.to(this.el, {
        x: '-1.5rem',
        ease: 'none',
        duration: 0.25,
        onComplete: this.cbMoveOnComplete
      })
      : gsap.to(this.el, {
        x: 0,
        ease: 'none',
        duration: 0.25,
        onComplete: this.cbMoveOnComplete
      })
  }

  //
  // ----- Callback methods
  //

  cbCenterOnComplete (status = false) {
    // console.log('Utils - ComponentPositioner: cbCenterOnComplete - invoked, set this.active to ', status)
    this.active = status
  }

  cbResizeOnComplete () {
    // console.log('Utils - ComponentPositioner: cbResizeOnComplete - invoked')
  }

  cbMoveOnComplete () {
    // console.log('Utils - ComponentPositioner: cbMoveOnComplete - invoked')
  }

  onWindowResize = debounce(() => {
    this.resize()
  }, 500)
}

export default ComponentPositioner
